import React, { useState, useEffect } from "react";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import ViewBookModel from "../Modals/ViewBookModel";
import Spinner from "react-bootstrap/Spinner";

const Booked = () => {
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];
  const [counter, setCounter] = useState(0);

  const {
    error,
    isLoading,
    data: events,
  } = useFetch(`${main_link}bookIndex?user_id=${user_id}`, counter);

  const [show, setShow] = useState(false);
  const [eventDetails, setEventDetails] = useState([]);

  const viewThisEvent = (event) => {
    // console.log("Event clicked:", event);
    setEventDetails(event.extendedProps);
    setShow(true);
    // console.log(event.extendedProps);
  };
  return (
    <>
      <ViewBookModel
        show={show}
        setShow={setShow}
        eventDetails={eventDetails}
      />

      <div>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Booked Cuts </h1>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Booked Cuts{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    title="Remove"
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                {/* calendar */}

                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  eventContent={(arg) => (
                    <div style={{ cursor: "pointer" }}>{arg.event.title}</div>
                  )}
                  eventClick={(info) => viewThisEvent(info.event)}
                  style={{ width: "50%", height: "400px", margin: "0 auto" }} // Adjust width and height here
                />

                {/* calendar */}
              </div>
              {/* /.card-body */}
              <div className="card-footer">Booked Cuts</div>
              {/* /.card-footer*/}
            </div>
            {/* /.card */}
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
      </div>
    </>
  );
};

export default Booked;
